module.exports = __webpack_public_path__ + "img/ic_link_share.71eed562.svg";